exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container[data-v-16b318d5]{height:100%\n}\n.new-project[data-v-16b318d5]{margin-bottom:40px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/demandas/components/ListagemPaineis.vue"],"names":[],"mappings":";AAyDA,4BACE,WAAY;CACb;AAAA,8BAGC,kBAAmB;CACpB","file":"ListagemPaineis.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.container {\n  height: 100%;\n}\n\n.new-project {\n  margin-bottom: 40px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16b318d5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/demandas/components/ListagemPaineis.vue
// module id = tfN1
// module chunks = 11